import { syncConditionalTextQuestions } from "./conditionalTextQuestions";
import {
  normalizeSelectDependencies,
  syncClonedSelectAnswers,
} from "./selectDependencies";
import { syncControlledSelectQuestions } from "./controlledSelectQuestions";

export function normalizeExamQuestions(questions) {
  return syncConditionalTextQuestions(
    syncClonedSelectAnswers(
      normalizeSelectDependencies(syncControlledSelectQuestions(questions))
    )
  );
}
